import { useContext } from 'react';
import { CultureContext, CultureContextValues } from './CultureProvider.context';

export function useCulture(): CultureContextValues {
    return useContext(CultureContext);
}
